// =====================================================================
// desligamento-perguntas.js — FONTE ÚNICA (frontend) da estrutura da
// Pesquisa de Desligamento reformulada (padrão Clima, nota por seção).
// Usada pelo questionário (renderiza) e pelo relatório (rótulos/escala).
//
// ESPELHA server/rh/desligamento-perguntas.js (backend). Os IDs P_N, as
// seções e a flag `pontua` PRECISAM ficar iguais nos dois arquivos — o
// backend usa a estrutura para pontuar, o front para renderizar. Ao mexer
// num, mexer no outro. (A duplicação é mínima e inevitável: CRA/ESM no front
// não compartilha módulo com o CommonJS do back — mesma limitação da Clima.)
//
// tipo: 'select' (categórica, fora da nota) | 'escala' (1-5, na nota) | 'texto' (livre, fora da nota)
// =====================================================================

// Escala de avaliação (5 → 1). A opção é gravada como TEXTO; o PESO converte p/ nota.
export const ESCALA = ['Excelente', 'Bom', 'Regular', 'Ruim', 'Péssimo'];
export const PESO = { 'Excelente': 5, 'Bom': 4, 'Regular': 3, 'Ruim': 2, 'Péssimo': 1 };

export const MOTIVOS = [
  'Melhor oportunidade de emprego',
  'Insatisfação com o ambiente de trabalho',
  'Mudança de carreira',
  'Horário não compatível com compromissos pessoais',
  'Não quero mais trabalhar',
  'Dispensado pela empresa',
  'Outros',
];

export const SECOES = [
  {
    id: 1, titulo: 'Motivo do Desligamento', pontua: false,
    perguntas: [
      { id: 'P_1', tipo: 'select', texto: 'Motivo do desligamento', opcoes: MOTIVOS },
      { id: 'P_2', tipo: 'select', texto: 'Voltaria a trabalhar na empresa?', opcoes: ['Sim', 'Não'] },
    ],
  },
  {
    id: 2, titulo: 'Experiência Geral', pontua: true,
    perguntas: [
      { id: 'P_3', tipo: 'escala', texto: 'Como avalia sua experiência geral na empresa?' },
      { id: 'P_4', tipo: 'escala', texto: 'Suas expectativas em relação ao trabalho foram atendidas?' },
    ],
  },
  {
    id: 3, titulo: 'Liderança', pontua: true,
    perguntas: [
      { id: 'P_5', tipo: 'escala', texto: 'Como avalia a relação com seu gestor/supervisor?' },
      { id: 'P_6', tipo: 'escala', texto: 'Como avalia a liderança da unidade?' },
    ],
  },
  {
    id: 4, titulo: 'Ambiente de Trabalho', pontua: true,
    perguntas: [
      { id: 'P_7', tipo: 'escala', texto: 'Como avalia o ambiente de trabalho?' },
      { id: 'P_8', tipo: 'escala', texto: 'Como era o relacionamento com a equipe?' },
    ],
  },
  {
    id: 5, titulo: 'Treinamento e Desenvolvimento', pontua: true,
    perguntas: [
      { id: 'P_9', tipo: 'escala', texto: 'Recebeu treinamento adequado para exercer sua função?' },
      { id: 'P_10', tipo: 'escala', texto: 'Os treinamentos foram úteis?' },
      { id: 'P_11', tipo: 'escala', texto: 'Teve oportunidades de desenvolvimento e crescimento?' },
    ],
  },
  {
    id: 6, titulo: 'Comunicação', pontua: true,
    perguntas: [
      { id: 'P_12', tipo: 'escala', texto: 'Como avalia a comunicação interna da empresa?' },
      { id: 'P_13', tipo: 'escala', texto: 'Recebia as informações necessárias para realizar seu trabalho?' },
    ],
  },
  {
    id: 7, titulo: 'Remuneração e Benefícios', pontua: true,
    perguntas: [
      { id: 'P_14', tipo: 'escala', texto: 'Como avalia salário, benefícios e reconhecimento?' },
    ],
  },
  {
    id: 8, titulo: 'Feedback Aberto', pontua: false,
    perguntas: [
      { id: 'P_15', tipo: 'texto', texto: 'Sugestões de melhorias' },
      { id: 'P_16', tipo: 'texto', texto: 'Comentários adicionais' },
      { id: 'P_17', tipo: 'texto', texto: 'Feedback sobre a empresa' },
    ],
  },
];

// Lista achatada de todas as perguntas (ordem P_1..P_17), útil p/ tabela/CSV.
export const TODAS_PERGUNTAS = SECOES.flatMap((s) => s.perguntas);
